import getEnv from "../env";

const env = getEnv();

let router: any = null;

function getRouter() {
    if (router) {
        return router;
    }
    // @ts-ignore
    let H = window.H;
    let platform = new H.service.Platform({
        apikey: env.HEREMAP_APIKEY,
    });
    router = platform.getRoutingService(null, 8);
    return router;
}
let transportModeMap = {
    CAR: "car",
    TWO_REAR_WHEELS_GT_50: "scooter",
    TWO_REAR_WHEELS_LTE_50: "scooter",
    BICYCLE: "bicyle",
};
// scooter

export async function getDistance(expenseReport: {
    origin: string;
    destination: string;
    vehiculeType: string;
}): Promise<number> {
    const { origin, destination, vehiculeType } = expenseReport;

    if (!origin || !destination || !vehiculeType) {
        return 0;
    }

    const localRouter: any = getRouter();

    let distance: number = 0;

    const routingParameters = {
        routingMode: "fast",
        transportMode: transportModeMap[vehiculeType],
        origin: origin,
        destination: destination,
        return: "travelSummary",
    };

    await localRouter.calculateRoute(
        routingParameters,
        (r) => {
            if (r?.routes?.[0]?.sections.length) {
                let s = r.routes[0].sections[0];
                if (s?.travelSummary?.length) {
                    distance = s.travelSummary.length;
                } else {
                    distance = 0;
                }
            } else {
                distance = 0;
            }
        },
        function (error) {
            console.log("DISTANCE error");
            console.error(error.message);
        },
    );
    return distance;
}
